import * as React from "react";
import { Navigate } from 'react-router-dom';

// components
import { getURLParamsByNames } from "../../coraWebComponents/utils/helper";

// routes
import Routes from "../../constants/Routes";

let alreadyRedirected = false;

class OAuthHandler extends React.Component {
  async componentDidMount() {
    let mainURL = window.location.href.split("?")[0];
    const { guid, code, provider, state } = getURLParamsByNames([
      "guid",
      "code",
      "provider",
      "state",
    ]);

    if (!alreadyRedirected || guid || code) {
      alreadyRedirected = true;

      let params = "";
      if (code && provider) params = `code=${code}&provider=${provider}`;
      else if (guid) params = `guid=${guid}`;
      else if (code) params = `code=${code}`;
      else mainURL = mainURL.split("#")[0];

      const browseToRegister = state && state === "createUser";
      const browseToLogin = (state && state === "logging") || guid;
      const browseToForgotPassword = code && provider === undefined;

      let route = `${mainURL}#${browseToRegister
        ? Routes.REGISTRACIA
        : browseToLogin
          ? Routes.LOGIN
          : browseToForgotPassword
            ? Routes.FORGOT_PASSWORD
            : Routes.LOGIN
        }?${params.replace("#/", "")}`;

      window.location.replace(route);
    }
  }

  render() {
    return <Navigate to={Routes.HOME} replace />
  }
}

export default OAuthHandler;
